<template>
  <div class="cart-items">
    <p class="cart-title">{{ Translator('front.cart.items.title') }}</p>

    <div class="cart-items-loader" v-if="!isReady"></div>
    <div class="cart-items-wrapper" v-if="isReady">
      <div class="cart-items-container" v-if="items && items.length > 0">
        <div class="cart-items-list">
          <cart-item v-for="item, index in items" :key="item.id" :index="index" v-bind:datas="item" />
        </div>
        <div class="cart-items-footer">
          <div class="cart-items-footer-actions">
            <button type="button" class="cart-button" @click="onOpen">
              <i class="ico ico-add-card"></i>
              {{ Translator('front.cart.items.add_button') }}
            </button>
            <button type="button" class="cart-button" @click="onOpenGrouped">
              <i class="ico ico-add-grouped"></i>
              {{ Translator('front.cart.items.grouped_button') }}
            </button>
          </div>
          <button type="button" class="cart-link" @click="onConnect" v-if="!isConnected">
            <i class="ico ico-save"></i>
            {{ Translator('front.cart.items.save') }}
          </button>
        </div>

        <div class="std-form">
          <button type="button" class="cart-link" @click="isShowedComment = true">
            <i class="ico ico-comment"></i>
            {{ Translator('front.cart.items.comment') }}
          </button>
          <div class="form-group form-group--is-placeholder" v-if="isShowedComment || form.comment">
            <textarea id="comment" class="form-control" v-model="form.comment" @blur="onDebounceKeyup" @keyup="onDebounceKeyup" :disabled="isSaving"></textarea>
          </div>
        </div>
        <cart-accessoires />
      </div>
      <div class="cart-emtpy" v-else>
        <p class="cart-emtpy-content">{{ Translator('front.cart.items.empty') }}</p>
        <div class="cart-emtpy-actions">
          <button type="button" class="cart-emtpy-button" @click="onOpen">
            <i class="ico ico-add-card"></i>
            {{ Translator('front.cart.items.add_button') }}
          </button>
          <button type="button" class="cart-emtpy-button" @click="onOpenGrouped">
            <i class="ico ico-add-grouped"></i>
            {{ Translator('front.cart.items.grouped_button') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
  .cart-items {
    .cart-items-title {
      @include title(3);
    }
    .cart-items-container {
      margin-bottom: rem(20);
    }
    .cart-items-footer {
      @include tablet {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }
    .cart-items-footer-actions {
      display: flex;
      align-items: center;
      gap: rem(10);
      @include mobile {
        flex-direction: column;
      }
      .cart-button {
        position: relative;
        padding-left: rem(50);
        .ico {
          font-size: rem(26);
          vertical-align: middle;
          position: absolute;
          left: rem(25);
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
    .cart-items-loader {
      @include loader;
      width: 100%;
      min-height: rem(300);
    }
    .cart-button {
      @include cta($white, $color-second);
    }
    .cart-link {
      @include resetBtn;
      color: $blue-udark;
      font-weight: 600;
      transition: color $transition-out-hover;
      margin-top: rem(15);
      margin-bottom: rem(15);
      .ico {
        font-size: rem(22);
        margin-right: rem(5);
      }
      &:hover, &:focus {
        color: $color-second;
        transition: color $transition-in-hover;
      }
    }
    .std-form {
      padding-left: rem(15);
      padding-right: rem(15);
      background-color: transparent;
      box-shadow: none;
    }
  }
  .cart-emtpy {
    @include container;
    @include vertical-spacing-bottom;
    text-align: center;
    padding: rem(30) rem(20);
    @include tablet {
      padding: rem(50) rem(30);
    }
    @include desktop {
      padding: rem(70) rem(40);
    }
    @include desktop-xl {
      padding: rem(100) rem(60);
    }
    .cart-emtpy-actions {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: rem(15);
      @include mobile {
        flex-direction: column;
      }
      @include tablet {
        gap: rem(30);
      }
    }
    .cart-emtpy-content {
      margin-bottom: rem(30);
    }
    .cart-emtpy-button {
      @include cta;
      position: relative;
      padding-left: rem(50);
      .ico {
        font-size: rem(26);
        vertical-align: middle;
        position: absolute;
        left: rem(25);
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
</style>
<script>
import debounce from 'debounce';
import AppControlService from '@/services/AppControl';
import UsersService from '@/services/Users';
import OrdersService from '@/services/Orders';
import CartItem from '@/components/CartItem';
import CartAccessoires from '@/components/CartAccessoires';

export default {
  name: 'cart-items',
  components: {
    CartItem,
    CartAccessoires
  },
  data () {
    return {
      items: null,
      isReady: false,
      cart: null,
      isShowedComment: false,
      isSaving: false,
      isConnected: UsersService.isConnected,
      previousSave: '',
      form: {
        comment: ''
      }
    }
  },

  created() {
    this._onUpdateCart = this._onUpdateCart.bind(this);
    this._onLogged = this._onLogged.bind(this);
    OrdersService.on('updated', this._onUpdateCart);
    UsersService.on('update', this._onLogged);
    if(this.isConnected) this.isReady = true;
    this._initCart();
  },

  beforeDestroy() {
    OrdersService.off('updated', this._onUpdateCart);
    UsersService.off('update', this._onLogged);
  },

  mounted() {
    const isLogged = document.querySelector('[data-logged]').dataset.logged === 'true';
    if(!isLogged) this.isReady = true;
  },

  computed: {
    isLimited: function() {
      return !this.cart?.validCountItems;
    }
  },

  methods: {
    onOpen() {
      if(!this.isConnected) return window.openLogin();
      AppControlService.openAddCard();
    },

    onOpenGrouped() {
      if(!this.isConnected) return window.openLogin();
      AppControlService.openGroupedCard();
    },

    onDebounceKeyup: debounce( function() {
      this._saveComment();
    }, 2000),

    onConnect() {
      window.openLogin();
    },

    _onLogged() {
      this.isConnected = UsersService.isConnected;
      if(UsersService.isConnected) this.isReady = true;
    },

    _onUpdateCart() {
      this._initCart();
    },

    _initCart() {
      if(OrdersService.cart) {
        this.cart = OrdersService.cart;
        this.items = OrdersService.cart.items;
        if(OrdersService.cart.comment) {
          this.form.comment = OrdersService.cart.comment;
          this.previousSave = OrdersService.cart.comment;
          if(this.form.comment !== '') this.isShowedComment = true;
        }
      } else this.items = null;
    },

    _saveComment() {
      if(this.isSaving) return;
      if(this.form.comment !== this.previousSave) {
        this.isSaving = true;
        this.previousSave = this.form.comment.trim();
        OrdersService.update({
          comment: this.form.comment
        }).then().then(() => {
          this.isSaving = false;
        })
      }
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },
  }
};
</script>
